module.exports = __webpack_public_path__ + "fonts/lovelo.310ed100.otf";